export default function set_array(key_array: string[], set_context: React.Dispatch<React.SetStateAction<any>>) {
  const get_array_new: { [key: string]: React.Dispatch<React.SetStateAction<any>> } = {};
  key_array.forEach((key: string) => {
    get_array_new[`set_${key}`] = (value: any) => {
      set_context((currentState: any): any => ({
        ...currentState,
        [key]: value
      }));
    };
  });
  return get_array_new;
}
